import gql from 'graphql-tag';
import _ from 'lodash';

import user from 'js/lib/user';

export const SettingsQuery = gql`
  query SettingsQuery($userId: String!) {
    ProgramMembershipsV2Resource {
      byUser(userId: $userId) {
        elements {
          id
          enterpriseProgram(eventualConsistency: true) {
            id
            thirdPartyOrganizationId
          }
        }
      }
    }
    ThirdPartyAccountsV1Resource {
      getAll {
        elements {
          id
          loginId
          identifier
        }
      }
    }
  }
`;

export const SettingsQueryOptions = {
  props: ({ data }: $TSFixMe) => {
    const programMemberships = data?.ProgramMembershipsV2Resource?.byUser?.elements || [];
    const thirdPartyAccounts = data?.ThirdPartyAccountsV1Resource?.getAll?.elements || [];
    const thirdPartyOrganizationIds =
      _.map(programMemberships, (x) => x.enterpriseProgram.thirdPartyOrganizationId) || [];
    return { thirdPartyOrganizationIds, thirdPartyAccounts };
  },
  options: () => ({
    variables: { userId: `${user.get().id}` },
    errorPolicy: 'all',
  }),
};
